import { Default } from '@master/annotation/Default'
import { getRawKey, RawKey } from '@master/annotation/RawKey'
import { isUndefined } from 'lodash/fp'

export class CpdGlobals {
  @Default('5')
  @RawKey('global_cpd_req_ethics')
  globalCpdReqEthics = undefined

  @Default('5')
  @RawKey('global_cpd_req_gi')
  globalCpdReqGi = undefined

  @Default('5')
  @RawKey('global_cpd_req_reg')
  globalCpdReqReg = undefined

  @Default('5')
  @RawKey('global_cpd_req_supp_ms')
  globalCpdReqSuppMs = undefined

  @Default('5')
  @RawKey('global_cpd_req_supp_others')
  globalCpdReqSuppOthers = undefined

  @RawKey('global_cpd_req_year')
  globalCpdReqYear = undefined

  getAllRawKeys () {
    return Object.keys(this).map((key) => {
      return getRawKey(this, key)
    })
  }

  extractData (data: any) {
    Object.keys(this).forEach(config => {
      const rawKey = getRawKey(this, config)
      if (rawKey in data) this[config] = data[rawKey]
    })
  }

  convertToRawData () {
    const raw = {}
    Object.keys(this).forEach(config => {
      const rawKey = getRawKey(this, config)
      if (!isUndefined(this[config])) {
        raw[rawKey] = String(this[config])
      }
    })
    return raw
  }
}
